import React, { useState, useEffect } from 'react'

import Gantt, {
  Tasks,
  // Dependencies,
  // Resources,
  // ResourceAssignments,
  Column,
  Editing,
  Toolbar,
  Item,
  ContextMenu,
  // Validation,
  // Texts,
} from 'devextreme-react/gantt'
// import { getImplementationScheduleByForm } from '../../../../../services/Elegibilidad/get'

import { Box, CircularProgress } from '@mui/material'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'
import { getImplementationScheduleByForm } from '../../../../../../services/Elegibilidad/get'
import { locale, loadMessages } from 'devextreme/localization'
const GantChartExtreme = ({ idElegibilityForm }) => {
  // const { step } = useFormElegibilidad()
  loadMessages({
    es: {
      Yes: 'Sí',
      'dxCollectionWidget-noDataText': 'No hay registros a desplegar',
      'dxDataGrid-noDataText': 'No hay registros a desplegar',
      'No data': 'No hay registros a desplegar',
      'dxListEditDecorator-delete': 'Eliminar',
      'dxDataGrid-editingDeleteRow': 'Eliminar',
      'dxDataGrid-editingConfirmDeleteMessage':
        '¿Está seguro que desea eliminar este registro?',
      'dxScheduler-confirmRecurrenceDeleteMessage':
        '¿Quiere eliminar solo esta cita o toda la serie?',
      'dxScheduler-confirmRecurrenceDeleteSeries': 'Eliminar serie',
      'Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?':
        'Eliminar',
      'dxDataGrid-editingUndeleteRow': 'ff',
      'dxGantt-dialogTaskDeleteConfirmation':
        '¿Está seguro que desea eliminar este registro?',
      'dxGantt-dialogDependencyDeleteConfirmation': 'prueba2',
      'dxGantt-dialogResourcesDeleteConfirmation': 'prueba3',
      'dxGantt-dialogStartTitle': 'Inicio',
      'dxGantt-dialogEndTitle': 'Fin',
      'dxGantt-dialogTaskDetailsTitle': 'Editar',
      'dxGantt-contextMenuDeleteTask': 'Eliminar actividad',
      'dxGantt-zoomIn': 'Ampliar',
      'dxGantt-zoomOut': 'Alejar',
      'dxGantt-deleteSelectedTask': 'Elimimar actividad',
    },
  })
  locale('es')
  const [state] = useEligibility()

  const [tasks, setTasks] = useState([])
  const [isLoading, setisLoading] = useState(true)

  const getTasksList = async () => {
    try {
      // toDo cambiar el id
      const response = await getImplementationScheduleByForm(idElegibilityForm)
      // setTasks(response.Data)
      const item = []
      for (let i = 0; i < response.Data.length; i++) {
        item[i] = {
          id: response.Data[i].IdImplementationSchedule,
          parentId: 0,
          title: response.Data[i].Activity,
          start: new Date(response.Data[i].StartDate),
          end: new Date(response.Data[i].EndDate),
        }
      }
      setTasks(item)
      if (response.Success) {
        setisLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 5 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tasks.length === 0
    ) {
      getTasksList()
    }
  }, [state.step])

  // const startDateRange = new Date(2018, 11, 1)
  // const endDateRange = new Date(2019, 11, 1)

  const onTaskDblClick = (e) => {
    if (e.key !== 0) {
      // your code
      e.cancel = true
    }
  }

  return (
    <>
      {isLoading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Gantt
          taskListWidth={500}
          scaleType="months"
          height={260}
          onTaskDblClick={onTaskDblClick}
          // startDateRange={startDateRange}
          // endDateRange={endDateRange}
        >
          <ContextMenu enabled={false} />
          <Tasks dataSource={tasks} />

          <Toolbar>
            {/* <Item name="undo" />
            <Item name="redo" />
            <Item name="separator" />
            <Item name="collapseAll" />
            <Item name="expandAll" />
            <Item name="separator" />
            <Item name="addTask" />
            <Item name="deleteTask" />
            <Item name="separator" /> */}
            <Item name="zoomIn" />
            <Item name="zoomOut" />
          </Toolbar>

          <Column dataField="title" caption="Actividad" width={300} />
          <Column dataField="start" caption="Fecha inicio" />
          <Column dataField="end" caption="Fecha fin" />

          {/* <Validation autoUpdateParentTasks /> */}
          <Editing enabled />
        </Gantt>
      )}
    </>
  )
}

export default React.memo(GantChartExtreme)
